module.exports = __webpack_public_path__ + "img/hk.e7e587ac.png";